<!-- Чекбокс с уникальным идентификатором и поддержкой сигналов -->
<label
  [attr.for]="checkboxId"
  class="app_checkbox-wrapper inline select-none"
  [class.checked]="!!value()"
  [class.cursor-pointer]="!disabled() && !loading()"
  [class.cursor-not-allowed]="disabled()"
  [class.cursor-wait]="loading()"
  [class.loading]="loading()"
  [class.disabled]="disabled()"
>
  <input
    [attr.id]="checkboxId"
    class="app_checkbox-default sr-only"
    type="checkbox"
    (click)="toggleCheckmark()"
    [(ngModel)]="value"
    (ngModelChange)="changeCheckbox($event)"
  />
  <div class="app_checkbox-label flex">
    <span class="app_checkbox-block inline-flex flex-shrink-0 items-center justify-center align-text-top">
      <span class="app_checkbox-checkmark ph ph-{{ iconType() }} font-medium"></span>
    </span>
    @if (showLabel()) {
      <span class="transition-colors duration-150 ease-in-out">
        @if (label(); as label) {
          {{ label }}
        } @else {
          <ng-content></ng-content>
        }
      </span>
    }
  </div>
</label>
